import { StoreLayout } from './layout/StoreLayout'

export const StoreScreen = () => {
  return (
    <StoreLayout />
  )
}
